import { ModuleSwitch } from "./ModuleSwitch";

// EOS-03 is one module with one sidebar entry, but more than one sizing engine
// (Master Prompt A17): this switch moves between them at the top of each page.
const SOURCE_PAGES = [
  { to: "/transformer-sizing", label: "Transformer" },
  { to: "/generator-sizing", label: "DG" },
  { to: "/ups-sizing", label: "UPS" },
  { to: "/pv-sizing", label: "PV" },
] as const;

export function SourceSizingSwitch() {
  return <ModuleSwitch label="Source sizing" pages={SOURCE_PAGES} />;
}

export default SourceSizingSwitch;
